import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';

export const AccountsUsersOutlet: FunctionComponent = () => <Outlet />;
